import styled from "styled-components";


export const HeroBg = styled.div`
position: absolute;
top: 0;
right: 0;
bottom: 0;
left: 0;
width: 100%;
height: 100%;
overflow: hidden;
z-index: 0;
// opacity: 1;
// transition: opacity 5s;
`;

export const HeroImg = styled.img`
width: 100%;
height: 100%;
-o-object-fit: cover;
object-fit: cover;
//background: #1c1e20;
//background-image: url("../img/home/des.png");
`;

export const VideoBg = styled.video`
width: 100%;
height: 100%;
-o-object-fit: cover;
object-fit: cover;
background: #000;
// opacity: 0.5;
// transition: opacity 5s;
`;